module.exports = __webpack_public_path__ + "static/media/btnimage.60b6f8a1.svg";